module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Promocja marki produktowej BIOSECO")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Promotion of the Product Brand BIOSECO")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna realizuje projekt pod tytułem:\n                „Promocja marki produktowej o znaczącym potencjale eksportowym - BPS- na zagranicznych targach i misjach gospodarczych szansą na wzmacnianie trwałego wzrostu i konkurencyjności Bioseco”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem projektu jest promocja marki produktowej o znaczącym potencjale eksportowym – Bioseco Bird Protection System (BPS) – na zagranicznych targach i misjach gospodarczych w okresie 01.02.2024-31.12.2026.\n                  Realizacja zadań zaplanowanych w projekcie umożliwi wzmocnienie konkurencyjności Bioseco na istniejących rynkach i wejście na nowe rynki Europy, Ameryki i świata.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, "), _c('br'), _vm._v("\n                  Priorytet: Środowisko sprzyjające innowacjom"), _c('br'), _vm._v("\n                  Działanie: Promocja marki innowacyjnych MŚP"), _c('br'), _vm._v("\n                  Umowa o dofinansowanie nr FENG.02.25-IP.02-0187/23\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Wartość projektu:"), _c('br'), _vm._v("\n                252 056.95 zł\n                "), _c('br'), _c('br'), _vm._v("\n                Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                126 028,48 zł\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna is implementing a project titled:\n                “Promotion of a Product Brand with Significant Export Potential - BPS - at International Trade Fairs and Economic Missions as an Opportunity to Strengthen Sustainable Growth and Competitiveness of Bioseco.”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to promote the product brand with significant export potential – Bioseco Bird Protection System (BPS) – at international trade fairs and economic missions during the period from February 1, 2024, to December 31, 2026.\n                The implementation of the tasks planned within the project will enhance Bioseco’s competitiveness in existing markets and facilitate entry into new markets in Europe, the Americas, and globally.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project is co-financed by the European Regional Development Fund under the program: European Funds for a Modern Economy,"), _c('br'), _vm._v("\n                Priority: Innovation-Friendly Environment"), _c('br'), _vm._v("\n                Action: Promotion of Innovative SME Brands"), _c('br'), _vm._v("\n                Grant Agreement No. FENG.02.25-IP.02-0187/23\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                252 056.95 PLN\n                "), _c('br'), _c('br'), _vm._v("\n                EU funding contribution:"), _c('br'), _vm._v("\n                126,028.48 PLN\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2a3c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PPBB.vue
// module id = 276
// module chunks = 0